import React from 'react'
import { t, Trans } from '@lingui/macro'
import Input from '../../../../components/common/form/input/Input'
import TimePicker from '../../../../components/common/date-time-pickers/TimePicker'
import Tooltip from '../../../../components/common/tooltip/Tooltip'
import IconInfo from '../../../../components/common/icon/IconInfo'
import { Box } from '../../../../components'
import { fontSizes } from '../../../../components/chakraThemeExtension'

type RelativeDayTimePickerProps = {
  setDay(day: number): void
  setTime(time: string): void
  time: string | null
  day: number | null
  prefixLabel: string
}

export const RelativeDayTimePicker: React.FC<RelativeDayTimePickerProps> = ({
  setDay,
  setTime,
  day,
  time,
  prefixLabel
}) => {
  return (
    <Box
      d="flex"
      alignItems="center"
      textAlign="left"
      pos="relative"
      paddingTop={prefixLabel ? '24px' : '0px'}
    >
      <Box
        as="span"
        textAlign="left"
        fontSize={fontSizes.md}
        mb="4px"
        position="absolute"
        top={0}
        left={0}
      >
        {prefixLabel}
      </Box>
      <Input
        type="number"
        className="ActionScheduleChoice__day"
        min="0"
        value={day ?? undefined}
        onChange={(val) => {
          setDay(+val)
        }}
      />
      <Trans>at</Trans>
      <TimePicker
        placeholder={t`Time`}
        mr="8px"
        value={time ? time.substr(0, 5) : ''}
        onChangeHandler={(val) => {
          setTime(val)
        }}
      />
      <Tooltip text={t`Day 0 is the same day the user joins the campaign`}>
        <IconInfo />
      </Tooltip>
    </Box>
  )
}
